module.exports = __webpack_public_path__ + "img/avatar7.58ba29a9.png";